import React from "react";
import { Box } from "@mui/material";
import ReactCountryFlag from "react-country-flag";
import colors from "../themes/colors";
import { classNames } from "../models/models";
import { country, CountryCode } from "../models/countryModels";
import OverflowTooltip from "./OverflowTooltip";

export interface LocationProps {
  countryCode?: CountryCode | number;
  city?: string;
  textClassName?: string;
  textColor?: string;
  flagSize?: "small" | "medium";
  flagRounded?: boolean;
}

const Location = ({
  countryCode,
  city,
  textClassName,
  textColor = colors.secondary.gray20,
  flagSize = "medium",
  flagRounded = false
}: LocationProps) => {
  const countryObject = country(countryCode as CountryCode);
  if (!countryObject) {
    return null;
  }

  const countyFlagSize = {
    width: flagSize === "small" ? "12px" : "24px",
    height: flagSize === "small" ? "9px" : "18px"
  };

  const text = [countryObject.alpha2, city].filter(x => x).join(", ");

  return (
    <Box className="flex items-center" color={colors.secondary.gray20}>
      <ReactCountryFlag
        countryCode={countryObject.alpha2}
        svg
        style={{
          width: `${countyFlagSize.width}`,
          height: `${countyFlagSize.height}`,
          borderRadius: flagRounded ? "2px" : "0"
        }}
      />

      <OverflowTooltip
        className={classNames(textClassName, "inline-block ml-1")}
        color={textColor}
        text={text}
      />
    </Box>
  );
};

export default Location;